import {SERVER_URL} from "../config";
import axios from "axios";
import {authHeader} from "_helpers";

function getOrganizationInfo(id) {
    const endpoint = `${SERVER_URL}/api/v1/organizations/${id}/settings/info`;
    return axios.get(endpoint, {
        headers: authHeader()
    });
}

function getOrganizationCSMs(organizationId) {
    const endpoint = `${SERVER_URL}/api/organizations/${organizationId}/csms`;
    return axios.get(endpoint, {
        headers: authHeader()
    });
}

function updateOrganizationAttribute(organizationId, payload) {
    const endpoint = `${SERVER_URL}/api/v1/organizations/${organizationId}/settings/update`;
    return axios.put(endpoint, payload, {
        headers: authHeader()
    });
}

function updateTicketBudget(organizationId, payload) {
    const endpoint = `${SERVER_URL}/api/v1/organizations/${organizationId}/settings/ticket-budget`;
    return axios.put(endpoint, payload, {
        headers: authHeader()
    });
}

function getDataSourceHandleInfo(organizationId) {
    const endpoint = `${SERVER_URL}/api/organizations/${organizationId}/data-source-handles`;
    return axios.get(endpoint, {
        headers: authHeader()
    });
}

function getTrendsDataSourceHandles(organizationTrendsId) {
    const endpoint = `${SERVER_URL}/api/v1/trends/organizations/${organizationTrendsId}/data-source-handles`;
    return axios.get(endpoint, {
        headers: authHeader()
    });
}

function getTrendsOrganization(organizationTrendsId) {
    const endpoint = `${SERVER_URL}/api/v1/trends/organizations/${organizationTrendsId}`;
    return axios.get(endpoint, {
        headers: authHeader()
    });
}

function updateTrendsOrganizationSetting(organizationTrendsId, payload) {
    const endpoint = `${SERVER_URL}/api/v1/trends/organizations/${organizationTrendsId}`;
    return axios.patch(endpoint, payload, {
        headers: authHeader()
    });
}

function getAutoActionsInfo(organizationId) {
    const endpoint = `${SERVER_URL}/api/organizations/${organizationId}/auto-actions`;
    return axios.get(endpoint, {
        headers: authHeader()
    });
}

function getOrganizationDisableProcesses(organizationId) {
    const endpoint = `${SERVER_URL}/api/organizations/${organizationId}/disable-processes`;
    return axios.get(endpoint, {
        headers: authHeader()
    });
}

function initiateDisableProcess(params) {
    const endpoint = `${SERVER_URL}/api/organizations/disable-processes`;
    return axios.post(endpoint, params,{
        headers: authHeader()
    })
}

function getOrganizationRemoveProcesses(organizationId) {
    const endpoint = `${SERVER_URL}/api/organizations/${organizationId}/remove-processes`;
    return axios.get(endpoint, {
        headers: authHeader()
    });
}

function initiateRemoveProcess(params) {
    const endpoint = `${SERVER_URL}/api/organizations/remove-processes`;
    return axios.post(endpoint, params,{
        headers: authHeader()
    })
}

const deleteSchedule = (params) => {
    const endpoint = `${SERVER_URL}/api/organizations/${params.orgId}/schedules/${params.id}`;
    return axios.delete(endpoint, {
        headers: authHeader()
    });
};

function getOrgMsgDataSourcesGroupedByMsgSource(organizationId) {
    const endpoint = `${SERVER_URL}/api/msgSources`;
    return axios.get(endpoint, {
        params: { organizationId },
        headers: authHeader()
    });
}

function listBlacklist(resource, paging) {
    const endpoint = `${SERVER_URL}/api/v1/trends/blacklist/${resource}`;
    return axios.get(endpoint, {
        headers: authHeader(),
        params: paging,
    });
}

function listTrendsOrganizations(params) {
    const endpoint = `${SERVER_URL}/api/v1/trends/organizations`;
    return axios.get(endpoint, {
        headers: authHeader(),
        params,
    });
}

function migrateTrendsOrganizationToTeams(organizationTrendsId) {
    const endpoint = `${SERVER_URL}/api/v1/trends/organizations/${organizationTrendsId}/migrate-to-teams`;
    return axios.post(endpoint, {}, {
        headers: authHeader(),
    });
}

function listTrendsAutoActions(params) {
    const endpoint = `${SERVER_URL}/api/v1/trends/auto-actions`;
    return axios.get(endpoint, {
        headers: authHeader(),
        params,
    });
}

function searchTrendsTags(params) {
    const endpoint = `${SERVER_URL}/api/v1/trends/tags`;
    return axios.get(endpoint, {
        headers: authHeader(),
        params,
    });
}

function createTrendsKeywordAutoAction(payload) {
    const endpoint = `${SERVER_URL}/api/v1/trends/auto-actions/keyword`;
    return axios.post(endpoint, payload, {
        headers: authHeader(),
    });
}

function createTrendsTagAutoAction(payload) {
    const endpoint = `${SERVER_URL}/api/v1/trends/auto-actions/tag`;
    return axios.post(endpoint, payload, {
        headers: authHeader(),
    });
}

function createTrendsMlAutoAction(payload) {
    const endpoint = `${SERVER_URL}/api/v1/trends/auto-actions/ml`;
    return axios.post(endpoint, payload, {
        headers: authHeader(),
    });
}

function createTrendsCompanyAlreadyRepliedAutoAction(payload) {
    const endpoint = `${SERVER_URL}/api/v1/trends/auto-actions/company-already-replied`;
    return axios.post(endpoint, payload, {
        headers: authHeader(),
    });
}

function deleteTrendsAutoAction(id) {
    const endpoint = `${SERVER_URL}/api/v1/trends/auto-actions/${id}`;
    return axios.delete(endpoint, {
        headers: authHeader(),
    });
}

function createBlacklistEntry(resource, payload) {
    const endpoint = `${SERVER_URL}/api/v1/trends/blacklist/${resource}`;
    return axios.post(endpoint, payload, {
        headers: authHeader()
    });
}

function deleteBlacklistEntry(resource, id) {
    const endpoint = `${SERVER_URL}/api/v1/trends/blacklist/${resource}/${id}`;
    return axios.delete(endpoint, {
        headers: authHeader()
    });
}

export const organizationSettingsService = {
    getOrganizationInfo,
    getDataSourceHandleInfo,
    getTrendsDataSourceHandles,
    getTrendsOrganization,
    updateTrendsOrganizationSetting,
    getAutoActionsInfo,
    getOrganizationCSMs,
    updateOrganizationAttribute,
    updateTicketBudget,
    getOrganizationDisableProcesses,
    initiateDisableProcess,
    getOrganizationRemoveProcesses,
    initiateRemoveProcess,
    deleteSchedule,
    getOrgMsgDataSourcesGroupedByMsgSource,
    listBlacklist,
    listTrendsOrganizations,
    migrateTrendsOrganizationToTeams,
    listTrendsAutoActions,
    searchTrendsTags,
    createTrendsKeywordAutoAction,
    createTrendsTagAutoAction,
    createTrendsMlAutoAction,
    createTrendsCompanyAlreadyRepliedAutoAction,
    deleteTrendsAutoAction,
    createBlacklistEntry,
    deleteBlacklistEntry,
}
